import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { AppState, Stage } from '@src/state/slices/types';
import { playerIsGeoblocked } from '@src/api/playerLocationAdapter';

const initialState: AppState = {
  isConnected: false,
  playerIsGeoblocked: false,
  stage: Stage.LOGIN,
  stageMeta: {},
  socketNonce: 0,
  showFullViewLoader: false,
  chat: {},
  connectedPlayers: 0,
  playerMetadata: null,
};

export const appSlice = createSlice({
  name: 'game',
  initialState,
  reducers: {
    setIsConnected: (state, action: PayloadAction<boolean>) => {
      state.isConnected = action.payload;
    },
    setStage: (
      state,
      action: PayloadAction<{ stage: Stage; stageMeta: AppState['stageMeta'] }>,
    ) => {
      state.stage = action.payload.stage;
      state.stageMeta = action.payload.stageMeta;
    },
    updateStageMeta: (state, action: PayloadAction<AppState['stageMeta']>) => {
      state.stageMeta = {
        ...state.stageMeta,
        ...action.payload,
      };
    },
    updateConnectedPlayers: (
      state,
      action: PayloadAction<AppState['connectedPlayers']>,
    ) => {
      state.connectedPlayers = action.payload;
    },
    incrementSocketNonce: (state) => {
      state.socketNonce = state.socketNonce + 1;
    },
    setShowFullViewLoader: (state, action: PayloadAction<boolean>) => {
      state.showFullViewLoader = action.payload;
    },
    handleNewChat: (
      state,
      action: PayloadAction<{
        room: string;
        playerName: string;
        message: string;
        playerId: string;
      }>,
    ) => {
      // create room array if it doesn't exist
      if (!state.chat[action.payload.room]) {
        state.chat[action.payload.room] = [];
      }

      // remove oldest message if there are more than 100
      if (state.chat[action.payload.room].length > 100) {
        state.chat[action.payload.room].shift();
      }

      state.chat[action.payload.room].push({
        playerId: action.payload.playerId,
        playerName: action.payload.playerName,
        message: action.payload.message,
      });
    },
    setPlayerMetadata: (
      state,
      action: PayloadAction<AppState['playerMetadata']>,
    ) => {
      state.playerMetadata = action.payload;
    },
  },
  extraReducers: (builder) => {},
});

export default appSlice.reducer;

export const {
  setIsConnected,
  setStage,
  updateStageMeta,
  incrementSocketNonce,
  setShowFullViewLoader,
  handleNewChat,
  updateConnectedPlayers,
  setPlayerMetadata,
} = appSlice.actions;
